export default "__VITE_ASSET__BblD5f_Q__"